import { render, staticRenderFns } from "./AllSections.vue?vue&type=template&id=74aee0f4&"
import script from "./AllSections.vue?vue&type=script&lang=js&"
export * from "./AllSections.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports